import React, {useState, useRef} from "react";
import {useHistory} from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import AuthService from "../Services/auth.service";
import logo from '../Assets/Images/dacott.png';



const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const Login=(props)=> {

  const form = useRef();
  const checkBtn = useRef();

  const [firstname, setfirstname] = useState("");
  const [password, setpassword] = useState("");
  const [loading, setloading] = useState(false);
  const [message, setmessage] = useState("");
  

  const onChangeFirstname=(e)=> {
    setfirstname(e.target.value);
  }

  const onChangePassword=(e)=> {
    setpassword(e.target.value);
  }
  let history = useHistory();
  const handleLogin=(e)=> {
    e.preventDefault();

    setmessage("");
    setloading(true);

    form.current.validateAll();


    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(firstname, password).then(
        () => {
          history.push("/user");
          window.location.reload();
        },
        (error) => {
          const resMessage = (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();

          setloading(false);
          setmessage(resMessage);
        }
      );
    } else {
      setloading(false);
    }
  }

  return (
    <div className="col-md-12">
      <div className="card card-container">
        <img src={logo} alt="profile-img" className="card-img-top"/>

        <Form onSubmit={handleLogin} ref={form}>
          <div className="form-group">
            <label htmlFor="firstname">Firstname</label>
            <Input
              type="text"
              className="form-control"
              name="firstname"
              value={firstname}
              onChange={onChangeFirstname}
              validations={[required]}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <Input
              type="password"
              className="form-control"
              name="password"
              value={password}
              onChange={onChangePassword}
              validations={[required]}
            />
          </div>

          <div className="form-group">
            <button
              className="btn btn-block"
              style={{backgroundColor:'#090979', color:'white'}}
              disabled={loading}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Login</span>
            </button>
          </div>

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          <CheckButton style={{ display: "none" }} ref={checkBtn}/>
        </Form>
      </div>
    </div>
  );
}
export default Login;